import type { ClauseListKey } from '@root/@types/types';
import { getClauseTypeForClauseListKey } from '@root/helpers/clauses';
import pluralize from 'pluralize';

/** Cosmetic placeholder text for mentions — does not affect data-id resolution. */
export const getMentionLabelSegment = (id: string): string => {
  const lastSegment = id.split('.').pop()!;
  const clauseType = getClauseTypeForClauseListKey(id as ClauseListKey);

  if (clauseType) {
    const slug = clauseType.toLocaleLowerCase().replaceAll(' ', '_');
    return `list_of_${pluralize(slug)}`;
  }

  return lastSegment;
};
